// extracted by mini-css-extract-plugin
module.exports = {"bsFormControl":"bsFormControl_bsFormControl__2VMQK","inline":"bsFormControl_inline__2Nl4d"};